export function isImmutable(obj) {
  // @ts-ignore intentionally not adding a dep on immutable
  return typeof obj.keySeq === 'function';
}